/* eslint-disable react/display-name */

import ReassignmentValueButton from '../components/ReassignmentValueButton';
import { AWAY } from '../constants/agent-state';
import { getAgentState, getAvatarUrl, getEmail, getFirstName, getLastName, isBot } from './assignees';
import { jsx as _jsx } from "react/jsx-runtime";
export const currentAssigneeValueRenderer = ({
  currentAssignee,
  loadingAssignee
}) => ({
  text
}) => {
  const DEFAULT_BOT_NAME = 'HubBot';
  let assigneeWithDefaults;
  if (currentAssignee) {
    assigneeWithDefaults = {
      avatar: getAvatarUrl(currentAssignee),
      away: getAgentState(currentAssignee) === AWAY,
      email: getEmail(currentAssignee),
      firstName: isBot(currentAssignee) ? DEFAULT_BOT_NAME : getFirstName(currentAssignee),
      lastName: getLastName(currentAssignee)
    };
  } else {
    assigneeWithDefaults = {
      avatar: null,
      away: false,
      email: null,
      firstName: null,
      lastName: null
    };
  }
  return /*#__PURE__*/_jsx(ReassignmentValueButton, Object.assign({
    loading: loadingAssignee,
    text: text,
    responder: currentAssignee
  }, assigneeWithDefaults));
};